<coin-v2-tabs
  [type]="type()"
  [defaultToFirstTab]="defaultToFirstTab()"
  (tabSelected)="navigateOnTabSelect($event)">
  @for (tab of tabs(); track tab.route()) {
    <ng-template
      [coinTab]="tab.content()"
      [icon]="tab.icon()"
      [isDisabled]="tab.isDisabled()"
      [disabledTooltip]="tab.disabledTooltip()"
      [lazy]="tab.lazy()"
      [cache]="tab.cache()"
      [route]="tab.route()"
      [isHidden]="tab.isHidden()"></ng-template>
  }
</coin-v2-tabs>
